import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
const FerryBannerSlider = {

    init() {
        console.log('FerryBannerSlider init called, element length:', $('.ferryBannerSwiper').length);
        if ($('.ferryBannerSwiper').length > 0) {
            console.log('FerryBannerSlider: element found, initializing Swiper...');
            this.initSlider();
        } else {
            console.log('FerryBannerSlider: element NOT found in DOM!');
        }
    },
    initSlider() {
        new Swiper($('.ferryBannerSwiper')[0], {
            loop: true,
            autoplay: {
                delay:5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },    
            speed: 500,
            // pauseOnMouseEnter: {
            //     disableOnInteraction: false,
            // },
            pagination: {
                el: '.swiper-pagination',
                clickable: 'true',
            },
            modules: [Navigation, Pagination,Autoplay],
        });
    },
  
}
export default FerryBannerSlider;



// WEBPACK FOOTER //
// ./scripts/modules/components/_ferry-banner.js